import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { updateClaimCode } from '~/services/ClaimCampaignService';

import type { UpdateClaimCodeBody } from '~/types/claimCampaignTypes';

import { claimCampaignQueryKeys } from './claimCampaignQueryKeys';

interface UpdateClaimCodeParams {
  campaignId: string;
  codeId: string;
  body: UpdateClaimCodeBody;
}

export function useUpdateClaimCode() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ campaignId, codeId, body }: UpdateClaimCodeParams) => {
      return await updateClaimCode(campaignId, codeId, body);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: claimCampaignQueryKeys.codes(variables.campaignId) });
      enqueueSnackbar('Code updated successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error updating code: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
